import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

interface MouseIconProps extends SvgIconProps {}

export const MouseIcon = (props: MouseIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg
                width="22"
                height="24"
                viewBox="0 0 22 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.176353 21.8118C-0.0961258 22.7525 0.721713 23.6359 1.58869 23.3374L20.3395 16.8816C21.3536 16.5325 21.3937 14.9931 20.3993 14.5825L12.0848 11.1494C11.7825 11.0245 11.5445 10.7645 11.4317 10.4359L8.25754 1.18975C7.88428 0.102471 6.45281 0.142827 6.13221 1.24967L0.176353 21.8118Z"
                    fill="black"
                />
            </svg>
        </SvgIcon>
    )
}